import { useTranslation } from 'react-i18next';
import { MenuButton, Button, Icon } from '@chakra-ui/react';
import { FaChevronDown } from 'react-icons/fa';
import { ISelectOption } from '../CustomSelect';

export interface ICustomSelectBtn {
  options?: ISelectOption[];
  value?: string | number;
  error?: boolean;
  disable?: boolean;
  renderBtnEl?: any;
}

export const CustomSelectBtn = ({ options, value, error, disable, renderBtnEl }: ICustomSelectBtn) => {
  const { t } = useTranslation();
  const optionEl = Array.isArray(options) && options.find((el) => el?.value === value);
  const { label } = optionEl || {};

  return (
    <MenuButton
      as={Button}
      isDisabled={disable}
      fontWeight='normal'
      size='lg'
      background='brand.formInputBgColor'
      borderRadius="md"
      width='100%'
      textAlign='left'
      border='1px solid'
      px={4}
      borderColor={error ? 'pink.500' : 'brand.formInputBgColor'}
      _hover={{ bg: 'brand.formInputBgColor', borderColor: disable ? 'brand.formInputBgColor' : 'gray.300' }}
      _active={
        disable
          ? undefined
          : {
              bg: 'brand.formInputBgColor',
              borderColor: 'brand.fontColor',
              boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)',
            }
      }
      rightIcon={
        <Icon
          as={FaChevronDown}
          w='24px'
          h='24px'
          p='6px'
          backgroundColor='white'
          borderRadius='50%'
          alignSelf='flex-end'
        />
      }
    >
      {label ? t(`${label}`) : renderBtnEl && renderBtnEl(optionEl)}
    </MenuButton>
  );
};
